import { Injectable } from '@angular/core';
import { MatchingProperty } from 'app/event/models/matching-property';
import { MatchingPropertyAssign } from 'app/event/models/matching-property-assign';
import { MatchingPropertyField } from 'app/event/models/matching-property-field';
import { PropertyMatch } from 'app/event/models/property-match';
import { MatchingPropertyStore } from 'app/event/service/matching-property.store';
import { PagesizeType } from 'app/event/service/pagination/pagesize-type';
import { UserLocalStorageService } from 'app/permission/services/user.local.storage.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../constants';
import { Page } from '../models/page';

@Injectable()
export class MatchingPropertyService {
  private selectedProperty: BehaviorSubject<MatchingProperty> = new BehaviorSubject<MatchingProperty>(null);
  selectedProperty$: Observable<MatchingProperty> = this.selectedProperty.asObservable();

  private selectedField: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  selectedField$: Observable<string> = this.selectedField.asObservable();

  private selectedPage: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  selectedPage$: Observable<number> = this.selectedPage.asObservable();

  private currentField: string;
  private currentDirection: string;
  private currentPage: number;

  constructor(
    private matchingPropertyStore: MatchingPropertyStore,
    private userLocalStorageService: UserLocalStorageService
  ) {
    this.init();
  }

  protected init(): void {
    this.setDefaultSort();
    this.setDefaultPage();
  }

  public setSelectedProperty(property: MatchingProperty) {
    this.selectedProperty.next(property);
  }

  public resetSelectedProperty(): void {
    this.selectedProperty.next(null);
  }

  public setSelectedField(field: string) {
    this.selectedField.next(field);
  }

  public resetSelectedField(): void {
    this.selectedField.next(Constants.DEFAULT_MATCHING_PROPERTY_FIELD_SORT_FIELD);
    this.setDefaultSort();
  }

  public setSelectedPage(page: number) {
    this.selectedPage.next(page);
  }

  public resetSelectedPage(): void {
    this.selectedPage.next(null);
  }

  public setCurrentField(field: string) {
    this.currentField = field;
  }

  public setCurrentDirection(direction: string) {
    this.currentDirection = direction;
  }

  public assignMatchingCandidate(property: MatchingPropertyAssign): Observable<any> {
    return this.matchingPropertyStore.assignMatchingCandidate(property);
  }

  public refreshMatchingProperties(page: number): Observable<any> {
    this.currentPage = page;

    return this.matchingPropertyStore.getMatchingProperties(
      this.currentPage,
      this.userLocalStorageService.getPagesize(PagesizeType.MATCHING_PROPERTY),
      this.currentField,
      this.getSecondarySource(this.currentField),
      this.currentDirection
    );
  }

  public addProperty(newRec: PropertyMatch): Observable<MatchingProperty> {
    return this.matchingPropertyStore.addProperty(newRec);
  }

  private setDefaultSort() {
    this.currentField = Constants.DEFAULT_MATCHING_PROPERTY_FIELD_SORT_FIELD;
    this.currentDirection = Constants.SORT_DIRECTION_ASC;
  }

  private setDefaultPage() {
    this.currentPage = Constants.SEARCH_DEFAULT_PAGE;
  }

  get properties(): Observable<Page<MatchingProperty>> {
    return this.matchingPropertyStore.properties;
  }

  get totalPropertyCount(): Observable<number> {
    return this.matchingPropertyStore.totalPropertyCount;
  }

  public getSecondarySource(field: string): string {
    if (field === MatchingPropertyField.CREATED_DATE) {
      return MatchingPropertyField.VENDOR_SOURCE;
    } else if (field === MatchingPropertyField.VENDOR_SOURCE) {
      return MatchingPropertyField.CREATED_DATE;
    } else {
      return MatchingPropertyField.MATCHING_PROPERTY_ID;
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/matching-property/matching-property.service.ts